// extracted by mini-css-extract-plugin
module.exports = {"link":"CompanyContentBoost_link___SKhm"};